import React from "react"
import Helmet from "react-helmet"

const WebComponentStairs = props => {
  if (props.data && props.data.plaintext)
    return (
      <>
        <Helmet>
          <script type="module" src="/static/js/original_DfbStairsMain.js" />
        </Helmet>
        <dfb-stairs-main content={props.data.plaintext} />
      </>
    )
  else return null
}

export default WebComponentStairs
